module.exports = __webpack_public_path__ + "static/img/frame 3.1e578ea7.png";